import { Permission } from '@/features/auth/use-auth';
import { jwtDecode as jwtDecodeOriginal } from 'jwt-decode';

type JwtPayload = {
  application_whitelist: string[];
  groups: string[];
};

type DecodedUmaTicketAccessToken = {
  authorization?: {
    permissions?: Permission[];
  };
  realm_access?: {
    roles: string[];
  };
};

export const decodeAccessToken = (token: string) => {
  const decoded = jwtDecodeOriginal<JwtPayload>(token);

  return {
    application_whitelist: decoded?.application_whitelist ?? [],
    groups: decoded?.groups ?? [],
  };
};

export const decodeUmaTicket = (token: string) => {
  const decoded =
    jwtDecodeOriginal<DecodedUmaTicketAccessToken>(token);

  return {
    permissions: decoded?.authorization?.permissions ?? [],
    roles: decoded?.realm_access?.roles ?? [],
  };
};
